<template>

  <div class="panel form">
       <el-form ref="form" :model="form" label-width="150px" class="edit_form">
          <el-form-item label="学生"  >
              <el-select v-model="form.userId"  remote filterable  placeholder="请输入学生姓名"  :remote-method="userSearch" @change="changeLoad()" >
                  <el-option
                      v-for="item in students"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.sn }}</span>
                  </el-option>
              </el-select>
          </el-form-item>
      </el-form>
      <div>
          <div id="talent" style="width:500px;height:376px;float:left"></div>
          <div id="interest" style="width:500px;height:376px;float:left"></div>
          <div id="skillPoint" style="width:500px;height:376px;float:left"></div>
      </div>

  </div>
</template>
<script>
  export default {
    data() {
        return{
            form: {keywords:'',userId:''},
            pager: {
                pageSize: 20,
                dataTotal: 0,
                currentPage: 1
            },
            students:[],
            talentOptions: {
                color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                title: {
                    text: '天赋值：'
                },
                radar: {
                    indicator: [
                      { text: '天赋值',max:100},
                      { text: '题库分值',max:100},
                      { text: '考试分值',max:100},
                      { text: '作业分值',max:100},
                    ],
                    startAngle: 90,
                    splitNumber: 4,
                    shape: 'circle',
                    name: {
                        formatter: '{value}',
                        color: '#000'
                    },
                    splitArea: {
                        areaStyle: {
                          color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                          shadowColor: 'rgba(0, 0, 0, 0.2)',
                          shadowBlur: 10
                        }
                      },
                      axisLine: {
                          lineStyle: {
                            color: 'rgba(160, 211, 250, 0.8)'
                          }
                      },
                  },
                  series: [
                    {
                      type: 'radar',
                      data: [
                        {
                          value: [0,0,0,0],
                          label: {
                            show: true,
                            formatter: function (params) {
                              return params.value;
                            }
                          },
                          areaStyle: {
                             color: 'rgba(255, 228, 52, 0.6)'
                          }
                        }
                      ]
                    }
                ]
            },
            interestOptions: {
                title: {
                    text: '兴趣值：'
                },
                radar: {
                    indicator: [
                      { name: '兴趣值'},//,max: 500
                      { name: '刷题量'},
                      { name: '挑战量'},
                      { name: '作业量'},
                      { name: '普通作品量'},
                      { name: '考试作品量'},
                      { name: '作品总量'},
                    ],
                    splitNumber: 4,
                    //shape: 'circle',
                    splitArea: {
                        areaStyle: {
                          color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                          shadowColor: 'rgba(0, 0, 0, 0.2)',
                          shadowBlur: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                           color: 'rgba(211, 253, 250, 0.8)'
                        }
                    },
                    splitLine: {

                    },
                  },
                  series: [
                    {
                      type: 'radar',
                      data: [
                        {
                          value: [],
                          label: {
                            show: true,
                            formatter: function (params) {
                              return params.value;
                            }
                          }
                        }
                      ]
                    }
                ]
            },
        }

    },
    mounted() {
       //this.drawChart()
    },
    watch: {},
    methods: {
            drawChart() {
               let talentChart = this.echarts.init(document.getElementById("talent"));
               // 指定图表的配置项和数据 this.talentOptions
               // 使用刚指定的配置项和数据显示图表。
               talentChart.setOption(this.talentOptions);
               // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
               //let interestChart = this.echarts.init(document.getElementById("interest"));
               //interestChart.setOption(this.interestOptions);
               //let skillPointChart = this.echarts.init(document.getElementById("skillPoint"));
               //skillPointChart.setOption(this.skillPointOptions);

            },
            userSearch(query) {
                //this.form.keywords = query;
                this.$ajaxPost("/user/list", {
                    form: {isStudent:true,classId:"",keywords:query},
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    this.students = data.result;
                })
            },
            changeLoad(){
                //this.form.userId = 1;
                if(this.form.userId != ''){
                    this.$ajaxGet("/talentStatistics/getStatistics/"+this.form.userId, (data) => {
                        if(data.result){
                            this.talentOptions.series[0].data[0].value = data.result.talentStatistics;
                            let datas = data.result.interestStatistics;//[212, 58, 20, 44, 145, 29, 57, 16]
                            let maxNum = Math.max.apply(null, datas);//最大值
                            if(maxNum == 0){
                                maxNum = 1;
                            }
                            let interestChart = this.echarts.init(document.getElementById("interest"));
                            let interestOptions = {
                                color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                                title: {
                                    text: '兴趣值：'
                                },
                                radar: {
                                    indicator: [
                                      { name: '兴趣值',max:maxNum},
                                      { name: '刷题量',max:maxNum},
                                      { name: '挑战量',max:maxNum},
                                      { name: '作业量',max:maxNum},
                                      { name: '普通作品量',max:maxNum},
                                      { name: '考试作品量',max:maxNum},
                                      { name: '作品总量',max:maxNum},
                                    ],
                                    splitNumber: 4,
                                    shape: 'circle',
                                    name: {
                                        formatter: '{value}',
                                        color: '#000',
                                    },
                                    splitArea: {
                                        areaStyle: {
                                          color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                                          shadowColor: 'rgba(0, 0, 0, 0.2)',
                                          shadowBlur: 10
                                        }
                                    },
                                    axisLine: {
                                        lineStyle: {
                                           color: 'rgba(160, 211, 250, 0.8)'
                                        }
                                    },
                                  },
                                  series: [
                                    {
                                      type: 'radar',
                                      data: [
                                        {
                                          value: datas,
                                          label: {
                                            show: true,
                                            formatter: function (params) {
                                              return params.value;
                                            }
                                          },
                                          areaStyle: {
                                              color: 'rgba(255, 228, 52, 0.6)'
                                          }
                                        }
                                      ]
                                    }
                                ]
                            };
                            interestChart.setOption(interestOptions);
                            //this.interestOptions.series[0].data[0].value = data.result.interestStatistics;
                            this.drawChart()
                        }
                    })
                    this.$ajaxGet("/skillPoint/getStatistics/"+this.form.userId, (data) => {
                        if(data.result){
                            let datas = data.result.skillPointStatistics;//[67, 58, 20, 44, 145, 29, 57, 16]
                            let maxNum = Math.max.apply(null, datas);//最大值
                            if(maxNum == 0){
                                maxNum = 1;
                            }
                            let skillPointChart = this.echarts.init(document.getElementById("skillPoint"));
                            let skillPointOptions = {
                                color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                                title: {
                                    text: '技能点：'
                                },
                                radar: {
                                    indicator: [
                                      { name: '运动',max:maxNum},
                                      { name: '外观',max:maxNum},
                                      { name: '声音',max:maxNum},
                                      { name: '事件',max:maxNum},
                                      { name: '控制',max:maxNum},
                                      { name: '侦测',max:maxNum},
                                      { name: '运算',max:maxNum},
                                      { name: '数据',max:maxNum},
                                    ],
                                    splitNumber: 4,
                                    shape: 'circle',
                                    name: {
                                        formatter: '{value}',
                                        color: '#000'
                                      },
                                    splitArea: {
                                        areaStyle: {
                                          color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                                          shadowColor: 'rgba(0, 0, 0, 0.2)',
                                          shadowBlur: 10
                                        }
                                    },
                                    axisLine: {
                                        lineStyle: {
                                          color: 'rgba(160, 211, 250, 0.8)'
                                        }
                                    },
                                    splitLine: {

                                    },
                                  },
                                  series: [
                                    {
                                      type: 'radar',
                                      data: [
                                        {
                                          value: datas,
                                          label: {
                                            show: true,
                                            formatter: function (params) {
                                              return params.value;
                                            }
                                          },
                                          areaStyle: {
                                             color: 'rgba(255, 228, 52, 0.6)'
                                          }
                                        }
                                      ]
                                    }
                                ]
                            };
                            skillPointChart.setOption(skillPointOptions);
                            //this.skillPointOptions.series[0].data[0].value = data.result.skillPointStatistics;
                            //this.drawChart()
                        }
                    })
                }
                return ;
            },

    },
    created() {
        this.changeLoad();
    }
  }
</script>



